import ReactDOM from 'react-dom';
import { useEffect } from '@wordpress/element';

// Ensure shared modal host is mounted and window.JkitOpenPricingModal is available
import '../shared/modal-host';

const SELECTOR = '.jkit-pro-banner a.upgrade, [id^="elementor-panel-category-jkit-pro-"] .jkit-pro-promotion a';

const EditorHost = () => {
    useEffect(() => {
        const onClick = (e) => {
            const el = e.target.closest && e.target.closest(SELECTOR);
            if (!el) return;

            try {
                e.preventDefault();
                e.stopPropagation();
                if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            } catch (err) {
                // ignore
            }

            if (typeof window.JkitOpenPricingModal === 'function') {
                window.JkitOpenPricingModal();
                return;
            }

            const href = (el.getAttribute && el.getAttribute('href')) || (window.location.origin + '/wp-admin/admin.php?page=jkit');
            window.open(href, '_blank');
        };

        document.addEventListener('click', onClick, true);
        document.addEventListener('auxclick', onClick, true);
        return () => {
            document.removeEventListener('click', onClick, true);
            document.removeEventListener('auxclick', onClick, true);
        };
    }, []);

    return null;
};

const mount = () => {
    if (typeof document === 'undefined') return;
    let root = document.getElementById('jkit-editor-host-root');
    if (!root) {
        root = document.createElement('div');
        root.id = 'jkit-editor-host-root';
        document.body.appendChild(root);
    }

    try {
        if (ReactDOM && typeof ReactDOM.createRoot === 'function') {
            ReactDOM.createRoot(root).render(<EditorHost />);
        } else {
            ReactDOM.render(<EditorHost />, root);
        }
    } catch (e) {
        ReactDOM.render(<EditorHost />, root);
    }
};

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    mount();
} else {
    window.addEventListener('load', mount);
}

export default {};
